import { Type } from 'typebox';
export const APIError = Type.Object({
    code: Type.String({ minLength: 1 }),
    message: Type.String({ minLength: 1 })
});
export class ApiTransportError extends Error {
    path;
    constructor(path, cause) {
        super(`API request failed before receiving a response for ${path}`, { cause });
        this.name = 'ApiTransportError';
        this.path = path;
    }
}
export class ApiRequestError extends Error {
    path;
    responseBody;
    status;
    statusText;
    constructor(options) {
        super(options.message);
        this.name = 'ApiRequestError';
        this.path = options.path;
        this.responseBody = options.responseBody;
        this.status = options.status;
        this.statusText = options.statusText;
    }
}
export class UnauthorizedApiRequestError extends ApiRequestError {
    constructor(options) {
        super({
            message: `Unauthorized request for ${options.path}`,
            path: options.path,
            responseBody: options.responseBody,
            status: 401,
            statusText: options.statusText
        });
        this.name = 'UnauthorizedApiRequestError';
    }
}
export class ApiResponseParseError extends Error {
    path;
    constructor(path, cause) {
        super(`Failed to parse API response for ${path}`, { cause });
        this.name = 'ApiResponseParseError';
        this.path = path;
    }
}
export class ApiResponseError extends Error {
    error;
    path;
    constructor(options) {
        super(`API response reported an error for ${options.path}`);
        this.name = 'ApiResponseError';
        this.error = options.error;
        this.path = options.path;
    }
}
